var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeedSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66699C5.40533 1.66699 1.66699 5.40533 1.66699 10.0003V13.4528C1.66699 14.3062 2.41449 15.0003 3.33366 15.0003H4.16699C4.38801 15.0003 4.59997 14.9125 4.75625 14.7562C4.91253 14.6 5.00033 14.388 5.00033 14.167V9.88116C5.00033 9.66015 4.91253 9.44818 4.75625 9.2919C4.59997 9.13562 4.38801 9.04783 4.16699 9.04783H3.41033C3.87366 5.82283 6.64866 3.33366 10.0003 3.33366C13.352 3.33366 16.127 5.82283 16.5903 9.04783H15.8337C15.6126 9.04783 15.4007 9.13562 15.2444 9.2919C15.0881 9.44818 15.0003 9.66015 15.0003 9.88116V15.0003C15.0003 15.9195 14.2528 16.667 13.3337 16.667H11.667V15.8337H8.33366V18.3337H13.3337C15.172 18.3337 16.667 16.8387 16.667 15.0003C17.5862 15.0003 18.3337 14.3062 18.3337 13.4528V10.0003C18.3337 5.40533 14.5953 1.66699 10.0003 1.66699Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedSupport);
export default __webpack_public_path__ + "static/media/NeedSupport.f7d2f3adfd644869b193b49e4cfb35d1.svg";
export { ForwardRef as ReactComponent };